export const FETCH_USER_INFO_REQUEST = 'homeReducer/FETCH_USER_INFO_REQUEST';
export const FETCH_USER_INFO_SUCCESS = 'homeReducer/FETCH_USER_INFO_SUCCESS';
export const FETCH_USER_INFO_FAILED = 'homeReducer/FETCH_USER_INFO_FAILED';

export const CREATE_CLASSROOM_REQUEST = 'homeReducer/CREATE_CLASSROOM_REQUEST';
export const CREATE_CLASSROOM_SUCCESS = 'homeReducer/CREATE_CLASSROOM_SUCCESS';
export const CREATE_CLASSROOM_FAILED = 'homeReducer/CREATE_CLASSROOM_FAILED';
export const CREATE_CLASSROOM_RESET = 'homeReducer/CREATE_CLASSROOM_RESET';

export const JOIN_CLASSROOM_REQUEST = 'homeReducer/JOIN_CLASSROOM_REQUEST';
export const JOIN_CLASSROOM_SUCCESS = 'homeReducer/JOIN_CLASSROOM_SUCCESS';
export const JOIN_CLASSROOM_FAILED = 'homeReducer/JOIN_CLASSROOM_FAILED';
export const JOIN_CLASSROOM_RESET = 'homeReducer/JOIN_CLASSROOM_RESET';

export const UPDATE_CLASSROOM_REQUEST = 'homeReducer/UPDATE_CLASSROOM_REQUEST';
export const UPDATE_CLASSROOM_SUCCESS = 'homeReducer/UPDATE_CLASSROOM_SUCCESS';
export const UPDATE_CLASSROOM_FAILED = 'homeReducer/UPDATE_CLASSROOM_FAILED';
export const UPDATE_CLASSROOM_RESET = 'homeReducer/UPDATE_CLASSROOM_RESET';

export const DELETE_CLASSROOM_REQUEST = 'homeReducer/DELETE_CLASSROOM_REQUEST';
export const DELETE_CLASSROOM_SUCCESS = 'homeReducer/DELETE_CLASSROOM_SUCCESS';
export const DELETE_CLASSROOM_FAILED = 'homeReducer/DELETE_CLASSROOM_FAILED';
export const DELETE_CLASSROOM_RESET = 'homeReducer/DELETE_CLASSROOM_RESET';

export const LEAVE_CLASSROOM_REQUEST = 'homeReducer/LEAVE_CLASSROOM_REQUEST';
export const LEAVE_CLASSROOM_SUCCESS = 'homeReducer/LEAVE_CLASSROOM_SUCCESS';
export const LEAVE_CLASSROOM_FAILED = 'homeReducer/LEAVE_CLASSROOM_FAILED';
export const LEAVE_CLASSROOM_RESET = 'homeReducer/LEAVE_CLASSROOM_RESET';